import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();
  
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home"
      className="relative min-h-screen flex items-center pt-20"
      style={{
        backgroundImage: 'url(https://public.readdy.ai/ai/img_res/3b17391c656f3395142f51abf3579eed.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-pink-100/95 via-amber-50/90 to-pink-50/85"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-pink-100/40"></div>
      
      <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 leading-tight drop-shadow-sm">
            {t('hero.title')} <span className="bg-gradient-to-r from-amber-500 to-amber-600 bg-clip-text text-transparent">{t('hero.titleHighlight')}</span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-800 mb-8 leading-relaxed drop-shadow-sm">
            {t('hero.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button 
              onClick={() => scrollToSection('puppies')}
              className="bg-gradient-to-r from-amber-500 to-amber-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:from-amber-600 hover:to-amber-700 transition-all shadow-xl hover:shadow-2xl cursor-pointer whitespace-nowrap"
            >
              {t('hero.viewPuppies')}
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-white/95 backdrop-blur-sm text-amber-600 px-8 py-4 rounded-full text-lg font-semibold hover:bg-white transition-all border-2 border-amber-500 shadow-lg cursor-pointer whitespace-nowrap"
            >
              {t('hero.contact')}
            </button>
          </div>
          
          <div className="grid grid-cols-3 gap-8 max-w-2xl mx-auto">
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">10+</div>
              <div className="text-amber-100">{t('hero.yearsExperience')}</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">500+</div>
              <div className="text-amber-100">{t('hero.happyFamilies')}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
